"use client";

import Navbar from "@/components/common/Navbar/Navbar";
import React, { useEffect } from "react";
import { useStoryContext } from "@/contexts/StoryContext";
import { User } from "@/gql/graphql";
import { LIST_NOTIFICATIONS } from "@/graphql/notifications";
import { useQuery } from "@apollo/client";
import {
  selectToken,
  selectUserId,
} from "@/lib/store/features/token/tokenSlice";
import { useAppSelector, useAppDispatch } from "@/lib/store/hooks";
import { setIsnotRead } from "@/lib/store/features/notifications/notificationSlice";
import RegisterCraftman from "../RegisterCraftman/RegisterCraftman";
import dynamic from "next/dynamic";
import SkeletonPost from "@/components/feed/SkeletonPost/SkeletonPost";
import useDeviceDetect from "@/hooks/useDeviceDetect";

const PostList = dynamic(() => import("@/components/feed/PostList/PostList"), {
  ssr: false,
  loading: () => <SkeletonPost />,
});

const StorySlide = dynamic(() => import("../Stories/StorySlide"), {
  ssr: false,
});

const MainContent = () => {
  const { haveUserStories } = useStoryContext();
  const id = useAppSelector(selectUserId);
  const token = useAppSelector(selectToken);
  const dispatch = useAppDispatch();
  const { isAndroid, isIPhone } = useDeviceDetect();
  const { data } = useQuery<{ user: User }>(LIST_NOTIFICATIONS, {
    variables: {
      skip: 0,
      take: 10,
      where: {
        id: id,
      },
    },
  });

  useEffect(() => {
    if (token) {
      if (data) {
        const totalNotificationsNotRead = data?.user.userNotifications.filter(
          (el) => el.read === false
        ).length;
        dispatch(setIsnotRead(totalNotificationsNotRead));
      }
    }
  }, [data, dispatch, token]);

  return (
    <div
      className={`flex flex-col h-full bg-white space-y-0 ${
        haveUserStories ? "md:space-y-8" : "md:space-y-0"
      } scrollbar-hide py-0 sm:py-5 md:py-0 px-0 lg:px-7 w-[100vw] sm:w-[85vw] md:w-[64vw] lg:w-[80vw] xl:w-[54vw]`}
    >
      <Navbar />
      <StorySlide />

      {/* call to action */}
      {!isAndroid && !isIPhone ? (
        <div className="flex w-full justify-between">
          <RegisterCraftman iPhone />
          <RegisterCraftman android />
        </div>
      ) : (
        <RegisterCraftman />
      )}

      <PostList />
    </div>
  );
};

export default MainContent;
